"use client";
import React from "react";
import Icon from "../../../components/primitives/icon";

interface StarRatingProps {
  rating: number;
  maxStars?: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function StarRating({
  rating,
  maxStars = 5,
  size = "md",
  className = "",
}: StarRatingProps) {
  const clampedRating = Math.max(0, Math.min(maxStars, rating));

  const stars = [];
  for (let i = 1; i <= maxStars; i++) {
    const fillPercentage = Math.min(
      100,
      Math.max(0, (clampedRating - i + 1) * 100)
    );

    stars.push(
      <div key={i} className="inline-block relative">
        <Icon
          name="star"
          size={size}
          className="text-secondary-600 align-text-bottom"
        />
        <div
          className="absolute inset-0 overflow-hidden"
          style={{ width: `${fillPercentage}%` }}
        >
          <Icon
            name="star"
            size={size}
            className="text-primary align-text-bottom"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {stars}
      <span className="ml-2 text-title-sm">
        {rating.toFixed(1)}/{maxStars}
      </span>
    </div>
  );
}
